<template>
  <div class="service-search-wrapper w-full text-xl">
    <div class="progress-bar hide-for-print hide-for-print">
      <ProgressBar :step="step" />
    </div>
    <template v-if="step === 3">
      <div>
        <p  class="block tracking-wide text-gray-700 text-xl font-bold mb-1 text-center hide-for-print">Top matches for your search:</p>
      </div>
      <template v-if="legal_issue_display_name != '' || myPCode != '' || search_query.demo_responses != ''">
        <div class="search-info justify-center p-5 hide-for-print text-center">
          <p v-if="legal_issue_display_name != ''"  class="text-xl"><strong>Legal Issue:</strong> {{ legal_issue_display_name }}</p>
          <p v-if="myPCode != ''"  class="text-xl"><strong>Location:</strong>  {{ myLocality }} </p>
          <p v-if="search_query.demo_responses != ''"  class="text-xl"><strong>Specialist requests:</strong> {{ demoChoicesDisplayList }}</p>
        </div>
      </template>
    </template>
    <!-- important steps -->
    <div aria-live="polite" class="wizard-content">
    <keep-alive>
      <SearchPageOne 
        :legal_questions="questions.legal_questions" 
        :legal_query="legal_query" 
        v-model:legal_issue="search_query.legal_issue"
        v-model:legal_issue_name="legal_issue_display_name"
        :key="page_one_key"
        v-if="step === 1" />
    </keep-alive>
    <keep-alive>
        <SearchPageTwo 
          :demographic_questions="questions.demographic_questions" 
          v-model:postcode="search_query.postcode"
          v-model:demo_responses="search_query.demo_responses"
          :key="page_two_key"   
          v-if="step === 2" />
      </keep-alive>
        <SearchResults 
          :search_query="search_query"
          :search_result="search_result"
          v-if="step === 3" />
    </div>
    
    <div class="flex justify-end mt-5 mb-5">
      <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" v-if="step === 3" @click="printResult()">Print results</button>
      <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" v-if="step > 1 && step <4" @click="stepForm(-1)">Previous</button>
      <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" v-if="step === 1" @click="stepForm(1)">Next</button>
      <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" v-if="step === 2" @click="makeQuery" >Submit</button>
      <button class="btn btn-blue m-2 text-xl sm:text-3xl hide-for-print" type="button" v-if="step === 3" @click="restartSearch">Start Over</button>
    </div>
    <!-- Printable area -->
    <div class="show-for-print">
      <PrintView 
          :search_query="search_query"
          :search_result="search_result"
          v-if="step === 3" />
    </div>

  </div><!-- end wrapper -->
</template>

<script>
import axios from 'axios'
import { ref, provide } from 'vue'
import ProgressBar from '../components/ProgressBar.vue'
import SearchPageOne from '../components/search-form/SearchPageOne.vue'
import SearchPageTwo from '../components/search-form/SearchPageTwo.vue'
import SearchResults from '../components/search-form/SearchResults.vue'
import PrintView from '../components/PrintView.vue'

export default {
  setup() {
    //try and provide a postcode value to decendant widget 
    const myPCode = ref(0)
    const myLocality = ref('')
    const setPostCode = value => {
      myPCode.value = value
    }
    const setLocality = value => {
      myLocality.value = value
    }

    provide('setPostCode', setPostCode)
    provide('setLocality', setLocality)

    return {
      myPCode,
      myLocality
    }
  },
  components: {
    SearchPageOne,
    SearchPageTwo,
    SearchResults,
    ProgressBar,
    PrintView,
  },
  data() {
    return {
      services_url: process.env.VUE_APP_SERVICES_BASE_URL,
      questions_url: process.env.VUE_APP_QUESTIONS_BASE_URL,
      questions: [],
      isActive: false,
      legal_query: [
        { "legal_area": "", "postcode": "", "demo_responses": [] }
      ],
      search_query: {
        legal_issue: "",
        postcode: "",
        demo_responses: []
      },
      legal_issue_display_name: "",
      service_list: [],
      step: 1,
      search_result: "",
      page_one_key: 0,
      page_two_key: 0
    }
  },
  async created() {
    // GET request using axios with async/await
    const response = await axios.get(process.env.VUE_APP_QUESTIONS_BASE_URL);
    this.questions = response.data;
    this.scrollToTop(); //try and start at the top
  },
  computed: {
    demoChoicesDisplayList: function() {
      var display_string = ""
      const myChoices = this.search_query.demo_responses;
      this.questions.demographic_questions.forEach(function (item) {
        if (myChoices.includes(item.f_value)) {
          display_string = display_string + ', ' + item.f_label;
        }
        //display_string = display_string + ', ' + item.f_label;
      });
      return display_string.substring(1);
    }
  },
  methods: {
    makeQuery(){
      this.step += 1;
      this.scrollToTop();
      const payload = {
          "legal_area" : this.search_query.legal_issue,
          "postcode" : this.myPCode,
          "demographic_data": this.search_query.demo_responses
      }
      console.log("payload: " + JSON.stringify(payload))
      axios.post(process.env.VUE_APP_SERVICES_BASE_URL, payload)
        .then((response)=> {
          console.log(response.status)
          //alert(JSON.stringify(response.data))
          this.search_result = response.data
        }).catch((error) => {
            console.warn('There was an error accessing the response...' + error);
        })

    },
    restartSearch() {
      this.search_query.legal_issue = "";
      this.search_query.postcode = "";
      this.search_query.demo_responses = [];
      this.myPCode = 0;
      this.legal_issue_display_name = "";
      this.step = 1;
      //make sure we return to the top
      this.scrollToTop();
      //Reset keys to force reset of components... not sure if this is bad practice or not.
      this.page_one_key += 1;
      this.page_two_key += 1;
    },
    printResult() {
      /* force a print window and hide unwanted content. Must be reproduced on all service page */
      document.title='Community legal services';
      window.print();
    },
    stepForm(stepValue) {
      //Move form in appropriate direction
      this.step += stepValue;
      //scroll to top to make sure elements arnt hidden on smaller screens
      this.scrollToTop();
    },
    scrollToTop(){
      window.scrollTo({top: 0 }); //iOS Safari doesn't support the "smooth" behaviour
      //window.scrollTo({top: 0, behavior: 'smooth'}); //when iOS 15 comes out we can revert. 
      //Could add some form of userAgent detection but maybe not worth it.
    }
  }
}
</script>

<style scoped>
.service-search-wrapper {
    text-align: left;
  }
  .submit-step {
    text-align: right;
  }
  .legal-problem-step,
  .postcode-step,
  .demographic-step {
    margin-bottom: 30px;
    filter: drop-shadow(0 0.2rem 0.25rem rgba(0, 0, 0, 0.2));
    padding: 15px;
    height: 100%;
    border: solid 0.5px;
  }
  .hide-form {
    display: none;
  }
</style>